import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 70px;
  margin-left: ${(props) => (props.lang === "en" ? "70px" : "0px")};
  margin-right: ${(props) => (props.lang === "ar" ? "70px" : "0px")};

  @media (max-width: 500px) {
    justify-content: center;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

const HeaderComponent = ({ to, children }) => {
  const { i18n } = useTranslation();
  return (
    <Header to={to} lang={i18n.language}>
      {" "}
      {children}{" "}
    </Header>
  );
};

export default HeaderComponent;
